import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGroup } from '@fortawesome/free-solid-svg-icons';

const GroupIcon = ({ size = 22, color = 'currentColor', className }) => (
  <FontAwesomeIcon
    icon={faUserGroup}
    className={className}
    style={{ fontSize: size, color, width: '1em', height: '1em' }}
  />
);

export default GroupIcon;
